
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hiring-solutions/executive-search",
      function () {
        return require("private-next-pages/hiring-solutions/executive-search/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hiring-solutions/executive-search"])
      });
    }
  